<template>
</template>
<script type="application/javascript">
export default {
    data() {
        return {}
    },
    mounted() {
        console.log("%cSTOP! Press F12", "font-size:45px;color:red;font-weight:bold;");
        console.log(`%c${this.$t('tip1')}`, "font-size:16px;color:#FF9800;font-weight:bold;");
        console.log(`%c${this.$t('tip3')}`, "font-size:16px;color:#FF9800;font-weight:bold;");
        console.log(`%c${this.$t('tip2')}`, "font-size:16px;color:#FF9800;font-weight:bold;");
    }
}
</script>
<style scoped lang="scss">
</style>
